module.exports = __webpack_public_path__ + "733d37a0ca14e0ef260f1a1df5406e46.fbx";